import React, { createContext, useContext } from 'react'
import { useSortable } from '@dnd-kit/sortable'
import type { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities'
import { HolderOutlined } from '@ant-design/icons'

const DragHandleContext = createContext<SyntheticListenerMap | undefined>(undefined)

export const DragHandle: React.FC = () => {
  const listeners = useContext(DragHandleContext)
  return (
    <HolderOutlined
      style={{ cursor: 'grab', touchAction: 'none', color: '#bfbfbf', fontSize: 16 }}
      {...listeners}
    />
  )
}

interface SortableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  'data-row-key': string
}

export const SortableRow: React.FC<SortableRowProps> = ({ 'data-row-key': rowKey, ...props }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: rowKey,
  })

  const style: React.CSSProperties = {
    ...props.style,
    transform: transform
      ? `translate3d(${transform.x}px, ${transform.y}px, 0) scaleY(${transform.scaleY ?? 1})`
      : undefined,
    transition,
    opacity: isDragging ? 0.5 : 1,
    position: isDragging ? 'relative' : undefined,
    zIndex: isDragging ? 1 : undefined,
  }

  return (
    <DragHandleContext.Provider value={listeners}>
      <tr {...props} ref={setNodeRef} style={style} {...attributes} />
    </DragHandleContext.Provider>
  )
}
